module.exports = __webpack_public_path__ + "static/media/Canvas-2.895a102d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Canvas-2.jpg
// module id = 1187
// module chunks = 0